import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useFrequencyTypes, FrequencyType } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<FrequencyType>
      useData={useFrequencyTypes}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
